import { render, staticRenderFns } from "./WikiCreate.vue?vue&type=template&id=456967e1"
import script from "./WikiCreate.vue?vue&type=script&lang=ts"
export * from "./WikiCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports